import React, { useState } from 'react';
import { Checkbox, Input, Button } from 'antd';

const CustomFilter = ({ filters, onFilter, clearFilters, confirm }) => {
  const [searchText, setSearchText] = useState('');
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleCheckboxChange = (value) => {
    const newSelectedFilters = selectedFilters.includes(value)
      ? selectedFilters.filter((item) => item !== value)
      : [...selectedFilters, value];
    setSelectedFilters(newSelectedFilters);
  };

  const handleReset = () => {
    setSelectedFilters([]);
    setSearchText('');
    clearFilters();
  };

  const handleConfirm = () => {
    onFilter(selectedFilters);
    confirm();
  };

  const filteredOptions = filters.filter((filter) =>
    filter.text.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div style={{ padding: 8 }}>
      <Input
        placeholder="Search"
        value={searchText}
        onChange={handleSearch}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <div style={{ maxHeight: 200, overflowY: 'auto' }}>
        {filteredOptions.map((filter) => (
          <div key={filter.value} style={{ marginBottom: 8 }}>
            <Checkbox
              checked={selectedFilters.includes(filter.value)}
              onChange={() => handleCheckboxChange(filter.value)}
            >
              {filter.text}
            </Checkbox>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 8 }}>
        <Button onClick={handleReset}>
          Reset
        </Button>
        <Button type="primary" onClick={handleConfirm}>
          OK
        </Button>
      </div>
    </div>
  );
};

export default CustomFilter;